module.exports = __webpack_public_path__ + "static/img/login_bg.461abe3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login_bg.png
// module id = aF6v
// module chunks = 1